import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import CISboholAdd from './cisBoholAdd';
import useBoholGetYear from '../Hooks/CisHooks/useBoholGetYear';  // this is to fetch all the data from cisbohol by year
import useGetYears from '../Hooks/CisHooks/useGetYears'; // get all years
import useDeleteCIS from '../Hooks/CisHooks/useDeleteCIS';
import useSubtotalsByYearCIS from '../Hooks/CisHooks/useSubtotalsByYearCIS';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';
import CisModal from './CisModal';
import DeleteConfirmationModal from '../Components/DeleteConfirmationModal'; 
import CISboholEdit from './cisBoholEdit';
import CISboholImport from './cisBoholimport';
import ExcelJS from 'exceljs';
import niaLogo from '../Assets/Logo.png';
import philippinesSeal from '../Assets/Bagong_Pilipinas_logo.png';
import { axiosApi } from '../api/setupApi';

const CISbohol = ({ darkMode, onSelect, isSidebarExpanded = false }) => {
  const nameOptions = ['Glenda', 'Joan', 'Hernel', 'Hernel 2', 'Princess', 'Charlie', 'Gerald', 'Nepthali', 'Janice', 'Severo'];
  const glendaIaNames = [
    'PONDOW IA',
    'TINGIW BAHI-AN FARMERS IA',
    'PANGAS QUINOGUITAN IA',
    'BUGANG NORTE-LOCTOB IA',
    'DIMIAONON IA',
    'BILAR ZAMRO IA',
    'CARMEN BUENOS AIRES IA',
    'DUCAM IA',
    'KUMILAW',
    'KUMILAW IA',
    'CANDELARIA MARANGOG IA',
    'PANGAS SOCON IA',
    'CANDUNGGON IA',
    'CAWASAN IA',
    'BINAOJOT IA',
    'PANAGDAGOOCAN IA',
  ];
  const joanIaNames = [
    'CAMBA-OL PROGRESO',
    'SUDLON IA',
    'ALICIA LA HACIENDA IA',
    'ILAUD LA HACIENDA IA',
    'KAWASAN-CAYACAY IA',
    'CALINGGANAY-CAINAGAG',
    'BOHOL BAGASICO IA',
    'ILAYA LA HACIENDA IA',
    'TANGKIGAN FARMERS IRRIG.',
    'MABINI SAN ISIDRO IA',
    'POMAB IA',
    'KASANBA IA',
    'MAGTALISIK IA',
    'CAPAYAS-GUISANGA-AN IS',
    'SAMABUYOG IA',
    'BUGCAN BUENAVISTA IA',
  ];
  const hernelIaNames = [
    'VILLANUEVA-TUBIGON IA INC.',
    'CAWAYANAN-BUNACAN-BOSONGON IA INC.',
    'TINANGNAN-UBUJAN-CABULIHAN IA INC.',
    'TALENCERAS-BOYLOG IA INC.',
    'CATA-TUBIGON IA INC.',
    'TINANGNAN ST. ISIDORE IA INC.',
    'MACAAS IA INC.',
    'CAHAYAG-TUBIGON IA INC.',
    'TUBIGON-PINAYAGAN IA INC.',
    'GENONOCAN FARMERS IA INC.',
    'MATABAO-BOHOL IA INC.',
    'ROXBIL IA INC.',
    'CAN-AGNAY IA INC.',
    'OWAC-CABALIJANO IA INC.',
    'YANAYA-BILAR IA INC.',
    'POBLACION-MASONOY IA INC.',
    'BAG-AO HIMATAO IA INC.',
    'MONTEVIDEO IA INC.',
    'TRABAJO MAS-ING IA INC.',
    'GUAVASAL IA INC.',
    'CLARIN LAJOG IA INC.',
    'POBLACION SUR-CANDAJEC IA INC.',
    'BACANI-COTAMA IA INC.',
    'NA-UB CLARIN IA INC.',
  ];
  const hernel2IaNames = [
    'TACAVION LOBOC IA',
    'BAGUMBAYAN-LOBOC IA',
    'JIMILI-AN BINATOAN IA',
    'JIMILI-AN BINATOAN IA INC.',
    'JIMILI AN BINATOAN IA',
    'JIMILI-AN BINATOAN IA',
    'JIMILIAN BINATOAN IA',
    'BAYAWAHAN AGAPUKO IA',
    'KANLAKAW IA',
    'PANGAOANAN LITTLE RICE IA',
    'CABANCALAN IA',
  ];
  const princessIaNames = [
    'ILIHAN TUBIGON IA',
    'BINOGAWAN-SAMBOLOC IA',
    'SOHOTON-CATMONAN IA(SCIA)',
    'TULTUGAN-CANAWON IA(TCIA)',
    'LIBORON-CALAPE IA',
    'LUCABSUN IA',
    'BANLASAN-CALAPE IA',
    'CABAYUGAN-CALAPE IA',
    'ANTEQUERA- BICAHAN IA',
    'CELING-DANLSAN IA',
    'SITIO BAHI-AN FARMERS IA',
    'TABUAN PASONG IA',
    'UBOJAN- ANTEQUERA IA',
    'BUSAO-AGAHAY- TORIL-STO. ROSARIO IA',
    'SUADIS IA',
    'CANSAWON IA',
    'KASANGAAN SMALL IA',
    'CAMABEROS IA',
    'LINDUGON IA',
  ];
  const charlieIaNames = [
    'MALAPOK IA',
    'CAISANG IA',
    'OGHOB IA',
    'CABACNITAN-BATUAN IA',
    'PAMONGBONG IA',
    'CABNTIGDAS BUNGA IA',
    'PANGIHAWAN DIMIAO IA',
    'BAUHUGAN IA',
    'GUINGOYURAN IA',
    'CANLAMBONG IA',
    'LAPSAON IA',
    'KA-INSON IA',
    'BAGUHAN IA',
    'KAPARO SPRING FARMERS IA',
    'LOGARITA RIVERSIDE IA',
    'DANAO SAWITE IA',
    'TINUGDAN SPRING IA',
    'CAMPAGAO ILAUD LINAW IA',
    'CAJAGO KASUNOGAN IA',
    'CATUGASAN IA',
    'MALICOGON IA',
    'CANSUMPA IA',
    'PINBANGIN IA',
    'SIMANG BALINGASAO ISA',
    'BEHIND THE CLOUDS IA',
    'BUGTONG BUD IA',
    'JAMBAWAN MULTI-PURPOSE COOPERATIVE',
  ];
  const geraldIaNames = [
    'S-BULLONES ST. ISIDORE IA INC.',
    'BUGSOC INTEGRATED IA INC.',
    'CADACA S-BULLONES IA INC.',
    'CAGYO DANAO IA INC.',
    'PANAYTAYON MATIN-AO IA INC.',
    'DUSITA DUAO IA INC.',
    'S-BULLONES CAPACUHAN IA INC.',
    'ABACHANAN NAPO IA INC.',
    'ABADALU IA INC.',
    'ABEHILAN ABACHANAN IA INC.',
    'ST. CRUZ S-BULLONES IA INC.',
    'LIKAFARM IA INC.',
    'CAMBANJES-SAN ISIDRO IA INC.',
    'BUENAVISTA PALAYAMANAN FARMERS IA INC.',
    'GABI POBLACION VIEJA IA INC.',
  ];
  const nepthaliIaNames = [
    'Bantayan Pilar Irrigators Association Inc.',
    'Ilaud Ilaya Irrigators Association Inc.',
    'DUERO GUINSULARAN FARMERS IA INC.',
    'LOB LA ROCA IA INC.',
    'Payao Duero Farmers Irrigators Association Inc.',
    'Cansuhay Ilaud Irrigators Association Inc.',
    'Pang-pang Imelda Farmers Irrigators Association Inc.',
    'Guinlob Irrigators Association Inc.',
    'Duero Lobogon Irrigators Association Inc.',
    'Sagnap Spring Irrigators Association Inc.',
    'Pilar Kubi Irrigators Association Inc.',
    'Inaghuban Irrigators Association Inc.',
    'Cansumbang Pilar Irrigators Association Inc.',
    'Pandayan Canbarong Irrigators Association Inc.',
    'Guindulman Catungawan Irrigators Association Inc.',
    'CASBAFA Bohol Irrigators Association Inc.',
    'BUSAW (Bulawan Sawang) Irrigators Association Inc.',
  ];
  const janiceIaNames = [
    'VILLARCAYO IA INC.',
    'AGIPO IA INC.',
    'KANGWASAY IA INC.',
    'CANTIJONG IA INC.',
    'LOQUIA (LOCTOB QUILATON IA) INC.',
    'MAHAWBO IA INC.',
    'BAHAJAN-BOYOG SUR IA INC.',
    'NAGKAHIUSANG MAG-UUMA SA TINUBDAN IA INC.',
    'DOROL-CANDASIG FARMERS IA INC.',
    'BALILIHAN TIWI IA INC.',
    'CAMASAQUE (CASAQUIA) INC.',
    'AMBUAN CATIGBIAN IA INC.',
    'HAGBUAYA SANGGABON IA INC.',
    'CABOG METHODICAL IA INC.',
    'CLARIN VILLAFLOR IA INC.',
    'CAMBITOON IA INC.',
    'M-U-C-U ILIHAN IA INC.',
    'KAPAYAWAN IA INC.',
    'CATIGBIAN IA INC.',
    'CABAGA-AS STA. CRUZ IA INC.',
  ];
  const severoIaNames = [
    'DAYRAY LA VICTORIA IA INC.',
    'LANTANG BINALIWAN IA INC',
    'CANDULAO IA',
    'MALIJAO DIMIAO IA INC.',
    'CATUGASAN DIMIAO IA INC',
    'CAJAM LA VICTORIA IA INC',
    'GINOPOLAN ANOYON IA INC.',
    'CUTCUTAN ILAYA IA',
    'DANAO VALENCIA IA',
    'PINBANGIN IA',
    'SIMANG BALINGASAO IA',
    'MOMIA IA INC.',
    'LIMOKON ILAYA IA INC.',
    'ACEBEL IA INC.',
    'CAMIA IA INC.',
    'AGHUBAN, CAMBUYO IA INC.',
    'CAMBATUAN- CALMA IA INC',
    'NAPO TABUAN IA INC',
    'VICANTIPOLO IA',
    'TOGBONGON ABIJILAN IA',
    'LOWER MANGNAN IA',
    'BUWAWIS UPPER CAHALOP IA',
    'BOTOC LA SALINAS IA',
    'POGOW IA INC',
    'TOCDOG DACU IA INC.',
  ];
  const CIS_MACHINERIES_RETURN_KEY = 'cisMachineriesReturn';
  const [selectedFile, setSelectedFile] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(false);
  const [showImportPanel, setShowImportPanel] = useState(false);
  const fileInputRef = useRef(null);
  const [showAllData, setShowAllData] = useState(true);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedName, setSelectedName] = useState('');
  const [allBoholData, setAllBoholData] = useState([]);
  const [addSuccessMessage, setAddSuccessMessage] = useState(null);
  const { years: yearData, loading: yearLoading, error: yearError, refetch: refetchYears } = useGetYears();
  const { data, loading, error, refetch} = useBoholGetYear(selectedYear);
  const { data: subtotals, loading: subtotalsLoading, error: subtotalsError } = useSubtotalsByYearCIS(selectedYear);
  const [headerImo, setHeaderImo] = useState(localStorage.getItem('headerImo') || 'BOHOL-CEBU-SIQUIJOR IMO');
  const [headerProfileDate, setHeaderProfileDate] = useState(localStorage.getItem('headerProfileDate') || 'CIS IA PROFILE as of March 31, 2025');
  const [headerRegion, setHeaderRegion] = useState(localStorage.getItem('headerRegion') || 'Region: 7');
  const [isEditingHeader, setIsEditingHeader] = useState(false);
  const { deleteCIS, loading: deleteLoading, error: deleteError } = useDeleteCIS();

  const role = (localStorage.getItem('role') || '').toLowerCase();
  const section = 'bohol';
  const showControls = role === 'admin' || role === section;
  const hideControlsForViewOnly = !showControls;



  const saveHeader = () => {
    localStorage.setItem('headerImo', headerImo);
    localStorage.setItem('headerProfileDate', headerProfileDate);
    localStorage.setItem('headerRegion', headerRegion);
    setIsEditingHeader(false);
  };

  const handleImportSuccess = async (newRecords) => {
    // Simulate API call to save new records (replace with actual API call)
    console.log('Saving imported records:', newRecords);
    const importedYear = Number(newRecords?.[0]?.years);
    if (!Number.isNaN(importedYear) && importedYear > 0) {
      setSelectedYear(importedYear);
    }
    setShowAllData(true);
    setSearchQuery('');
    setAddSuccessMessage('Data imported successfully!');
    setTimeout(() => setAddSuccessMessage(null), 3000);
    setShowImportPanel(false);
    await refetch();
  };

  const handleAddSuccess = async (msg) => {
    setAddSuccessMessage(msg || 'Data added successfully!');
    setTimeout(() => setAddSuccessMessage(null), 3000);
  };

 

  useEffect(() => {
    
    if (yearLoading) return;

    if (yearError) {
      const currentYear = new Date().getFullYear();
      setSelectedYear(currentYear);
      return;
    }

    if (Array.isArray(yearData) && yearData.length > 0) {
      const validYears = yearData
        .filter(year => typeof year === 'number' && !isNaN(year))
        .sort((a, b) => b - a);
      if (validYears.length > 0) {
        setSelectedYear(prev => prev ?? validYears[0]);
      } else {
        setSelectedYear(new Date().getFullYear());
      }
    } else {
      setSelectedYear(new Date().getFullYear());
    }
  }, [yearData, yearLoading, yearError]);

  useEffect(() => {
    if (yearError && !yearLoading) {
      const retry = setTimeout(() => refetchYears(), 3000);
      return () => clearTimeout(retry);
    }
  }, [yearError, yearLoading, refetchYears]);

  useEffect(() => {
    const pending = localStorage.getItem(CIS_MACHINERIES_RETURN_KEY);
    if (!pending) return;

    try {
      const parsed = JSON.parse(pending);
      if (parsed?.sectionKey && parsed.sectionKey !== 'CISBohol') return;

      if (parsed?.selectedItem) {
        setSelectedFile(parsed.selectedItem);
        setModalOpen(true);
      }

      if (parsed?.selectedYear) {
        setSelectedYear(parsed.selectedYear);
      }

      localStorage.removeItem(CIS_MACHINERIES_RETURN_KEY);
    } catch (err) {
      localStorage.removeItem(CIS_MACHINERIES_RETURN_KEY);
    }
  }, []);

  useEffect(() => {
    const loadAllBoholData = async () => {
      if (!selectedName || allBoholData.length > 0) return;
      try {
        const { data: allData } = await axiosApi.get('/cisBohol/byLabel');
        setAllBoholData(Array.isArray(allData) ? allData : []);
      } catch (err) {
        console.error('Failed to load fallback CIS data:', err);
      }
    };

    loadAllBoholData();
  }, [selectedName, allBoholData.length]);

  

  const handleClose = () => {
    setShowRightPanel(false);
  };

  const handleRowClick = (item) => {
    console.log('Row clicked:', item);
    setSelectedFile(item);
    setModalOpen(true);
    console.log('selectedFile:', item, 'modalOpen:', true);
  };

  const handleEditData = (item) => {
    setSelectedFile(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedFile(null);
  };

  const handleDeleteClick = (item) => {
  setConfirmDelete(item);
};

const handleCancelDelete = () => {
  setConfirmDelete(null);
};

const handleConfirmDelete = async () => {
  if (confirmDelete) {
    await deleteCIS(confirmDelete.id); // or whatever key you use
    setConfirmDelete(null);
  }
};

  const normalizeText = (value) =>
    (value || '')
      .toString()
      .trim()
      .toLowerCase();

  const normalizeIaName = (value) =>
    (value || '')
      .toString()
      .trim()
      .replace(/\s+/g, ' ')
      .toUpperCase();

  const normalizeIaKey = (value) =>
    (value || '')
      .toString()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, ' ')
      .replace(/\bIA\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const isLooseIaKeyMatch = (candidateKey, knownKey) => {
    if (!candidateKey || !knownKey) return false;
    if (candidateKey === knownKey) return true;

    // Guard against false positives from very short/placeholder keys like "NO"
    if (candidateKey.length < 8 || knownKey.length < 8) return false;

    if (candidateKey.includes(knownKey) || knownKey.includes(candidateKey)) return true;

    // Tolerate minor OCR/spelling differences by comparing token overlap.
    const candidateTokens = candidateKey.split(' ').filter((token) => token.length > 2);
    const knownTokens = knownKey.split(' ').filter((token) => token.length > 2);
    if (candidateTokens.length === 0 || knownTokens.length === 0) return false;

    const knownTokenSet = new Set(knownTokens);
    const overlapCount = candidateTokens.filter((token) => knownTokenSet.has(token)).length;
    const overlapRatio = overlapCount / Math.min(candidateTokens.length, knownTokens.length);

    return overlapCount >= 2 && overlapRatio >= 0.6;
  };

  const glendaIaSet = new Set(glendaIaNames.map(normalizeIaName));
  const glendaIaKeySet = new Set(glendaIaNames.map(normalizeIaKey));
  const joanIaSet = new Set(joanIaNames.map(normalizeIaName));
  const joanIaKeySet = new Set(joanIaNames.map(normalizeIaKey));
  const hernelIaSet = new Set(hernelIaNames.map(normalizeIaName));
  const hernelIaKeySet = new Set(hernelIaNames.map(normalizeIaKey));
  const hernel2IaSet = new Set(hernel2IaNames.map(normalizeIaName));
  const hernel2IaKeySet = new Set(hernel2IaNames.map(normalizeIaKey));
  const princessIaSet = new Set(princessIaNames.map(normalizeIaName));
  const princessIaKeySet = new Set(princessIaNames.map(normalizeIaKey));
  const charlieIaSet = new Set(charlieIaNames.map(normalizeIaName));
  const charlieIaKeySet = new Set(charlieIaNames.map(normalizeIaKey));
  const geraldIaSet = new Set(geraldIaNames.map(normalizeIaName));
  const geraldIaKeySet = new Set(geraldIaNames.map(normalizeIaKey));
  const nepthaliIaSet = new Set(nepthaliIaNames.map(normalizeIaName));
  const nepthaliIaKeySet = new Set(nepthaliIaNames.map(normalizeIaKey));
  const janiceIaSet = new Set(janiceIaNames.map(normalizeIaName));
  const janiceIaKeySet = new Set(janiceIaNames.map(normalizeIaKey));
  const severoIaSet = new Set(severoIaNames.map(normalizeIaName));
  const severoIaKeySet = new Set(severoIaNames.map(normalizeIaKey));
  const assignmentFields = [
    'assigned_to',
    'assignedTo',
    'assignee',
    'person_in_charge',
    'personInCharge',
    'prepared_by',
    'preparedBy',
    'collector',
    'encoder',
    'handler',
    'owner',
    'name',
    'idoAssigned',
    'ido_assigned',
  ];

  const isAssignedToPerson = (item, personName) => {
    const target = normalizeText(personName);

    const exactKnownFieldMatch = assignmentFields.some(
      (field) => normalizeText(item?.[field]) === target
    );

    if (exactKnownFieldMatch) return true;

    const exactHeuristicFieldMatch = Object.entries(item || {}).some(([key, value]) => {
      const looksLikeAssignmentField = /(assign|assignee|owner|prepared|encoder|collector|person|handler)/i.test(key);
      return looksLikeAssignmentField && normalizeText(value) === target;
    });

    return exactHeuristicFieldMatch;
  };

  const isGlendaAssigned = (item) => isAssignedToPerson(item, 'Glenda');

  const matchesIaList = (item, iaSet, iaKeySet) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const exactName = normalizeIaName(candidate);
      if (iaSet.has(exactName)) return true;

      const key = normalizeIaKey(candidate);
      if (iaKeySet.has(key)) return true;

      for (const knownKey of iaKeySet) {
        if (isLooseIaKeyMatch(key, knownKey)) return true;
      }

      return false;
    });
  };

  const isGlendaIaMatch = (item) => matchesIaList(item, glendaIaSet, glendaIaKeySet);
  const isHernelIaMatch = (item) => matchesIaList(item, hernelIaSet, hernelIaKeySet);
  const isHernel2IaMatch = (item) => matchesIaList(item, hernel2IaSet, hernel2IaKeySet);
  const isJoanIaMatch = (item) => matchesIaList(item, joanIaSet, joanIaKeySet);
  const isPrincessIaMatch = (item) => matchesIaList(item, princessIaSet, princessIaKeySet);
  const isCharlieIaMatch = (item) => matchesIaList(item, charlieIaSet, charlieIaKeySet);
  const isGeraldIaMatch = (item) => matchesIaList(item, geraldIaSet, geraldIaKeySet);
  const isNepthaliIaMatch = (item) => matchesIaList(item, nepthaliIaSet, nepthaliIaKeySet);
  const isJaniceIaMatch = (item) => matchesIaList(item, janiceIaSet, janiceIaKeySet);
  const isSeveroIaMatch = (item) => matchesIaList(item, severoIaSet, severoIaKeySet);
  const isJaniceStrictIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const exactName = normalizeIaName(candidate);
      if (janiceIaSet.has(exactName)) return true;

      const key = normalizeIaKey(candidate);
      return janiceIaKeySet.has(key);
    });
  };
  const isNepthaliStrictIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const exactName = normalizeIaName(candidate);
      if (nepthaliIaSet.has(exactName)) return true;

      const key = normalizeIaKey(candidate);
      return nepthaliIaKeySet.has(key);
    });
  };
  const isGeraldStrictIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const exactName = normalizeIaName(candidate);
      if (geraldIaSet.has(exactName)) return true;

      const key = normalizeIaKey(candidate);
      return geraldIaKeySet.has(key);
    });
  };
  const isGeraldPriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        hasAllTokens(key, ['BULLONES', 'ST', 'ISIDORE']) ||
        hasAllTokens(key, ['BULLONES', 'ST', 'ISIDRO']) ||
        hasAllTokens(key, ['BUGSOC', 'INTEGRATED']) ||
        hasAllTokens(key, ['CADACA', 'BULLONES']) ||
        hasAllTokens(key, ['CAGYO', 'DANAO']) ||
        hasAllTokens(key, ['PANAYTAYON', 'MATIN', 'AO']) ||
        hasAllTokens(key, ['DUSITA', 'DUAO']) ||
        hasAllTokens(key, ['BULLONES', 'CAPACUHAN']) ||
        hasAllTokens(key, ['ABACHANAN', 'NAPO']) ||
        key.includes('ABADALU') ||
        hasAllTokens(key, ['ABEHILAN', 'ABACHANAN']) ||
        hasAllTokens(key, ['CRUZ', 'BULLONES']) ||
        key.includes('LIKAFARM') ||
        hasAllTokens(key, ['CAMBANJES', 'SAN', 'ISIDRO']) ||
        hasAllTokens(key, ['BUENAVISTA', 'PALAYAMANAN', 'FARMERS']) ||
        hasAllTokens(key, ['GABI', 'POBLACION', 'VIEJA'])
      );
    });
  };
  const isNepthaliPriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        hasAllTokens(key, ['BANTAYAN', 'PILAR', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['ILAUD', 'ILAYA', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['DUERO', 'GUINSULARAN', 'FARMERS']) ||
        hasAllTokens(key, ['LOB', 'LA', 'ROCA']) ||
        hasAllTokens(key, ['PAYAO', 'DUERO', 'FARMERS', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['CANSUHAY', 'ILAUD', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['PANG', 'PANG', 'IMELDA', 'FARMERS', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['GUINLOB', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['DUERO', 'LOBOGON', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['SAGNAP', 'SPRING', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['PILAR', 'KUBI', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['INAGHUBAN', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['CANSUMBANG', 'PILAR', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['PANDAYAN', 'CANBARONG', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['GUINDULMAN', 'CATUNGAWAN', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['CASBAFA', 'BOHOL', 'IRRIGATORS', 'ASSOCIATION']) ||
        hasAllTokens(key, ['BUSAW', 'BULAWAN', 'SAWANG', 'IRRIGATORS', 'ASSOCIATION'])
      );
    });
  };
  const isJanicePriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        key.includes('VILLARCAYO') ||
        key.includes('AGIPO') ||
        key.includes('KANGWASAY') ||
        key.includes('CANTIJONG') ||
        hasAllTokens(key, ['LOQUIA', 'LOCTOB', 'QUILATON']) ||
        key.includes('MAHAWBO') ||
        hasAllTokens(key, ['BAHAJAN', 'BOYOG', 'SUR']) ||
        hasAllTokens(key, ['NAGKAHIUSANG', 'MAG', 'UUMA', 'TINUBDAN']) ||
        hasAllTokens(key, ['DOROL', 'CANDASIG', 'FARMERS']) ||
        hasAllTokens(key, ['BALILIHAN', 'TIWI']) ||
        hasAllTokens(key, ['CAMASAQUE', 'CASAQUIA']) ||
        hasAllTokens(key, ['AMBUAN', 'CATIGBIAN']) ||
        hasAllTokens(key, ['HAGBUAYA', 'SANGGABON']) ||
        hasAllTokens(key, ['CABOG', 'METHODICAL']) ||
        hasAllTokens(key, ['CLARIN', 'VILLAFLOR']) ||
        key.includes('CAMBITOON') ||
        hasAllTokens(key, ['M', 'U', 'C', 'U', 'ILIHAN']) ||
        key.includes('KAPAYAWAN') ||
        hasAllTokens(key, ['CATIGBIAN']) ||
        hasAllTokens(key, ['CABAGA', 'AS', 'STA', 'CRUZ'])
      );
    });
  };
  const isNepthaliRescueIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const stripGenericTokens = (key) =>
      key
        .split(' ')
        .filter(
          (t) =>
            t &&
            !['IA', 'INC', 'IRRIGATORS', 'ASSOCIATION', 'FARMERS', 'BOHOL'].includes(t)
        );

    const knownCoreTokens = Array.from(nepthaliIaKeySet).map((k) => stripGenericTokens(k));

    return iaCandidates.some((candidate) => {
      const candidateKey = normalizeIaKey(candidate);
      const candidateTokens = stripGenericTokens(candidateKey);
      if (candidateTokens.length === 0) return false;

      return knownCoreTokens.some((knownTokens) => {
        if (knownTokens.length === 0) return false;
        const knownSet = new Set(knownTokens);
        const overlap = candidateTokens.filter((t) => knownSet.has(t)).length;
        const ratio = overlap / Math.min(candidateTokens.length, knownTokens.length);
        return overlap >= 2 && ratio >= 0.7;
      });
    });
  };
  const isSeveroStrictIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const exactName = normalizeIaName(candidate);
      if (severoIaSet.has(exactName)) return true;

      const key = normalizeIaKey(candidate);
      return severoIaKeySet.has(key);
    });
  };
  const isSeveroPriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        hasAllTokens(key, ['DAYRAY', 'VICTORIA']) ||
        hasAllTokens(key, ['LANTANG', 'BINALIWAN']) ||
        key.includes('CANDULAO') ||
        hasAllTokens(key, ['MALIJAO', 'DIMIAO']) ||
        hasAllTokens(key, ['CATUGASAN', 'DIMIAO']) ||
        hasAllTokens(key, ['CAJAM', 'VICTORIA']) ||
        hasAllTokens(key, ['GINOPOLAN', 'ANOYON']) ||
        hasAllTokens(key, ['CUTCUTAN', 'ILAYA']) ||
        hasAllTokens(key, ['DANAO', 'VALENCIA']) ||
        key.includes('PINBANGIN') ||
        hasAllTokens(key, ['SIMANG', 'BALINGASAO']) ||
        key.includes('MOMIA') ||
        hasAllTokens(key, ['LIMOKON', 'ILAYA']) ||
        key.includes('ACEBEL') ||
        key.includes('CAMIA') ||
        hasAllTokens(key, ['AGHUBAN', 'CAMBUYO']) ||
        hasAllTokens(key, ['CAMBATUAN', 'CALMA']) ||
        hasAllTokens(key, ['NAPO', 'TABUAN']) ||
        key.includes('VICANTIPOLO') ||
        hasAllTokens(key, ['TOGBONGON', 'ABIJILAN']) ||
        hasAllTokens(key, ['LOWER', 'MANGNAN']) ||
        hasAllTokens(key, ['BUWAWIS', 'UPPER', 'CAHALOP']) ||
        hasAllTokens(key, ['BOTOC', 'SALINAS']) ||
        key.includes('POGOW') ||
        hasAllTokens(key, ['TOCDOG', 'DACU'])
      );
    });
  };
  const isHernel2PriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        key.includes('JIMILI AN BINATOAN') ||
        key.includes('JIMILIAN BINATOAN') ||
        key.includes('JIMILI BINATOAN') ||
        key.includes('JIMILIAN BINATOAN INC')
      );
    });
  };
  const isPrincessPriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        hasAllTokens(key, ['ILIHAN', 'TUBIGON']) ||
        hasAllTokens(key, ['BINOGAWAN', 'SAMBOLOC']) ||
        hasAllTokens(key, ['SOHOTON', 'CATMONAN']) ||
        hasAllTokens(key, ['TULTUGAN', 'CANAWON']) ||
        hasAllTokens(key, ['LIBORON', 'CALAPE']) ||
        key.includes('LUCABSUN') ||
        hasAllTokens(key, ['BANLASAN', 'CALAPE']) ||
        hasAllTokens(key, ['CABAYUGAN', 'CALAPE']) ||
        hasAllTokens(key, ['ANTEQUERA', 'BICAHAN']) ||
        hasAllTokens(key, ['CELING', 'DANLSAN']) ||
        hasAllTokens(key, ['SITIO', 'BAHI', 'AN', 'FARMERS']) ||
        hasAllTokens(key, ['TABUAN', 'PASONG']) ||
        hasAllTokens(key, ['UBOJAN', 'ANTEQUERA']) ||
        hasAllTokens(key, ['BUSAO', 'AGAHAY', 'TORIL', 'STO', 'ROSARIO']) ||
        key.includes('SUADIS') ||
        key.includes('SUADES') ||
        key.includes('CANSAWON') ||
        hasAllTokens(key, ['KASANGAAN', 'SMALL']) ||
        key.includes('CAMABEROS') ||
        key.includes('LINDUGON')
      );
    });
  };
  const isCharliePriorityIaMatch = (item) => {
    const iaCandidates = [
      item?.ia_name,
      item?.is_name,
      item?.iaName,
      item?.name_of_ia,
      item?.custom_ia_name,
    ].filter(Boolean);

    const hasAllTokens = (key, tokens) => tokens.every((token) => key.includes(token));

    return iaCandidates.some((candidate) => {
      const key = normalizeIaKey(candidate);
      return (
        key.includes('MALAPOK') ||
        key.includes('CAISANG') ||
        key.includes('OGHOB') ||
        hasAllTokens(key, ['CABACNITAN', 'BATUAN']) ||
        key.includes('PAMONGBONG') ||
        hasAllTokens(key, ['CABNTIGDAS', 'BUNGA']) ||
        hasAllTokens(key, ['CABANTIGDAS', 'BUNGA']) ||
        hasAllTokens(key, ['PANGIHAWAN', 'DIMIAO']) ||
        key.includes('BAUHUGAN') ||
        key.includes('GUINGOYURAN') ||
        key.includes('CANLAMBONG') ||
        key.includes('LAPSAON') ||
        hasAllTokens(key, ['KA', 'INSON']) ||
        key.includes('BAGUHAN') ||
        hasAllTokens(key, ['KAPARO', 'SPRING', 'FARMERS']) ||
        hasAllTokens(key, ['LOGARITA', 'RIVERSIDE']) ||
        hasAllTokens(key, ['DANAO', 'SAWITE']) ||
        hasAllTokens(key, ['TINUGDAN', 'SPRING']) ||
        hasAllTokens(key, ['CAMPAGAO', 'ILAUD', 'LINAW']) ||
        hasAllTokens(key, ['CAJAGO', 'KASUNOGAN']) ||
        key.includes('CATUGASAN') ||
        key.includes('MALICOGON') ||
        key.includes('CANSUMPA') ||
        key.includes('PINBANGIN') ||
        hasAllTokens(key, ['SIMANG', 'BALINGASAO', 'ISA']) ||
        hasAllTokens(key, ['SIMANG', 'BALINGASAO', 'IA']) ||
        hasAllTokens(key, ['BEHIND', 'THE', 'CLOUDS']) ||
        hasAllTokens(key, ['BUGTONG', 'BUD']) ||
        hasAllTokens(key, ['JAMBAWAN', 'MULTI', 'PURPOSE', 'COOPERATIVE'])
      );
    });
  };

  const matchesSelectedPerson = (item) => {
    if (!selectedName) return true;
    return isAssignedToPerson(item, selectedName);
  };

  const flattenedData = Array.isArray(data)
    ? data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    : [];

  const filteredData = flattenedData.filter(item =>
    Object.values(item).some(val =>
      (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    ) && (
      selectedName === 'Joan' || selectedName === 'Glenda' || selectedName === 'Hernel' || selectedName === 'Hernel 2' || selectedName === 'Princess' || selectedName === 'Charlie' || selectedName === 'Gerald' || selectedName === 'Nepthali' || selectedName === 'Janice' || selectedName === 'Severo'
        ? true
        : matchesSelectedPerson(item)
    )
  );

  const finalFilteredData = (() => {
    if (selectedName === 'Glenda') {
      const filterByGlendaIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && isGlendaIaMatch(item) && !isHernelIaMatch(item) && !isHernel2IaMatch(item) && !isJoanIaMatch(item) && !isPrincessIaMatch(item) && !isCharlieIaMatch(item);
        });

      const yearMatches = filterByGlendaIaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      return filterByGlendaIaList(allBoholData);
    }

    if (selectedName === 'Hernel') {
      const filterByHernelIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && isHernelIaMatch(item) && !isGlendaIaMatch(item) && !isHernel2IaMatch(item) && !isJoanIaMatch(item) && !isPrincessIaMatch(item) && !isCharlieIaMatch(item);
        });

      const yearMatches = filterByHernelIaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      return filterByHernelIaList(allBoholData);
    }

    if (selectedName === 'Hernel 2') {
      const matchesHernel2Ia = (item) => isHernel2IaMatch(item) || isHernel2PriorityIaMatch(item);

      const filterByHernel2IaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesHernel2Ia(item);
        });

      const yearMatches = filterByHernel2IaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      const allMatches = filterByHernel2IaList(allBoholData);
      if (allMatches.length > 0) return allMatches;

      // Final fallback so the dropdown still shows assigned records if IA naming differs in source data.
      return (Array.isArray(allBoholData) ? allBoholData : []).filter((item) => {
        const matchesSearch = Object.values(item).some((val) =>
          (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
        return matchesSearch && isAssignedToPerson(item, 'Hernel 2');
      });
    }

    if (selectedName === 'Princess') {
      const matchesPrincessIa = (item) => isPrincessIaMatch(item) || isPrincessPriorityIaMatch(item);

      const filterByPrincessIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesPrincessIa(item);
        });

      const yearMatches = filterByPrincessIaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      const allMatches = filterByPrincessIaList(allBoholData);
      if (allMatches.length > 0) return allMatches;

      return (Array.isArray(allBoholData) ? allBoholData : []).filter((item) => {
        const matchesSearch = Object.values(item).some((val) =>
          (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
        return matchesSearch && isAssignedToPerson(item, 'Princess');
      });
    }

    if (selectedName === 'Charlie') {
      const matchesCharlieIa = (item) => isCharlieIaMatch(item) || isCharliePriorityIaMatch(item);

      const filterByCharlieIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesCharlieIa(item);
        });

      const yearMatches = filterByCharlieIaList(filteredData);
      const allMatches = filterByCharlieIaList(allBoholData);

      // Use the fuller result set so Charlie dropdown does not get capped by year-limited data.
      if (allMatches.length > yearMatches.length) return allMatches;
      if (yearMatches.length > 0) return yearMatches;
      if (allMatches.length > 0) return allMatches;

      return (Array.isArray(allBoholData) ? allBoholData : []).filter((item) => {
        const matchesSearch = Object.values(item).some((val) =>
          (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
        return matchesSearch && isAssignedToPerson(item, 'Charlie');
      });
    }

    if (selectedName === 'Gerald') {
      const matchesGeraldIa = (item) => isGeraldStrictIaMatch(item) || isGeraldPriorityIaMatch(item);

      const filterByGeraldIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesGeraldIa(item);
        });

      const yearMatches = filterByGeraldIaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      const allMatches = filterByGeraldIaList(allBoholData);
      if (allMatches.length > 0) return allMatches;

      return [];
    }

    if (selectedName === 'Nepthali') {
      const matchesNepthaliIa = (item) => isNepthaliStrictIaMatch(item) || isNepthaliPriorityIaMatch(item);
      const expectedNepthaliCount = nepthaliIaNames.length;

      const filterByNepthaliIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesNepthaliIa(item);
        });

      const filterByNepthaliRescueList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && isNepthaliRescueIaMatch(item);
        });

      const yearMatches = filterByNepthaliIaList(filteredData);
      const allMatches = filterByNepthaliIaList(allBoholData);

      // Use the fuller strict set so Nepthali isn't capped by year-limited records.
      const baseMatches = allMatches.length > yearMatches.length ? allMatches : yearMatches;
      if (baseMatches.length >= expectedNepthaliCount) return baseMatches;

      const rescueYearMatches = filterByNepthaliRescueList(filteredData);
      const rescueAllMatches = filterByNepthaliRescueList(allBoholData);
      const rescueMatches = rescueAllMatches.length > rescueYearMatches.length ? rescueAllMatches : rescueYearMatches;

      if (baseMatches.length > 0 || rescueMatches.length > 0) {
        const seen = new Set();
        const merged = [...baseMatches, ...rescueMatches].filter((item) => {
          const key = item?.id != null ? `id:${item.id}` : `ia:${normalizeIaKey(item?.ia_name || item?.is_name || item?.iaName || item?.name_of_ia || '')}|cis:${(item?.cis_name || '').toString().toUpperCase()}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        return merged;
      }

      return [];
    }

    if (selectedName === 'Janice') {
      const matchesJaniceIa = (item) => isJaniceStrictIaMatch(item) || isJanicePriorityIaMatch(item);

      const filterByJaniceIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesJaniceIa(item);
        });

      const yearMatches = filterByJaniceIaList(filteredData);
      const allMatches = filterByJaniceIaList(allBoholData);

      if (allMatches.length > yearMatches.length) return allMatches;
      if (yearMatches.length > 0) return yearMatches;
      if (allMatches.length > 0) return allMatches;

      return [];
    }

    if (selectedName === 'Severo') {
      const matchesSeveroIa = (item) => isSeveroStrictIaMatch(item) || isSeveroPriorityIaMatch(item);

      const filterBySeveroIaList = (rows) =>
        (Array.isArray(rows) ? rows : []).filter((item) => {
          const matchesSearch = Object.values(item).some((val) =>
            (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
          );
          return matchesSearch && matchesSeveroIa(item);
        });

      const yearMatches = filterBySeveroIaList(filteredData);
      if (yearMatches.length > 0) return yearMatches;

      const allMatches = filterBySeveroIaList(allBoholData);
      if (allMatches.length > 0) return allMatches;

      return [];
    }

    if (selectedName !== 'Joan') {
      if (!selectedName || filteredData.length > 0) return filteredData;

      return (Array.isArray(allBoholData) ? allBoholData : []).filter((item) => {
        const matchesSearch = Object.values(item).some((val) =>
          (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
        return matchesSearch && matchesSelectedPerson(item);
      });
    }

    const filterByJoanIaList = (rows) =>
      (Array.isArray(rows) ? rows : []).filter((item) => {
        const matchesSearch = Object.values(item).some((val) =>
          (val?.toString()?.toLowerCase() || '').includes(searchQuery.toLowerCase())
        );
        return matchesSearch && isJoanIaMatch(item) && !isGlendaAssigned(item) && !isGlendaIaMatch(item) && !isHernelIaMatch(item) && !isHernel2IaMatch(item) && !isPrincessIaMatch(item) && !isCharlieIaMatch(item);
      });

    const yearMatches = filterByJoanIaList(filteredData);
    if (yearMatches.length > 0) return yearMatches;

    return filterByJoanIaList(allBoholData);
  })();

  const cisOrder = [...new Set(flattenedData.map(item => item.cis_name || 'Gravity'))];

  const uniqueCISGroups = Object.entries(
    finalFilteredData.reduce((acc, item) => {
      const group = item.label;
      if (!acc[group]) acc[group] = { items: [], subtotal: null };
      acc[group].items.push(item);
      return acc;
    }, {})
  ).sort(([a], [b]) => cisOrder.indexOf(a) - cisOrder.indexOf(b));

  if (subtotals) {
    uniqueCISGroups.forEach(([label, group]) => {
      group.subtotal = subtotals[label]?.subtotal || null;
    });
  }

  const subtotalByGroup = subtotals
    ? Object.entries(subtotals).reduce((acc, [key, value]) => {
        if (key === 'grandTotal') {
          acc.grandTotal = value;
        } else {
          acc.subtotals[key] = value.subtotal;
        }
        return acc;
      }, { subtotals: {}, grandTotal: null })
    : { subtotals: {}, grandTotal: null };

  const displayedGroups = showAllData
    ? uniqueCISGroups
    : uniqueCISGroups.slice(0, 1).map(([cis_name, group]) => [
        cis_name,
        { ...group, items: group.items.slice(-8) },
      ]);

  // ensure bottom scrollbar inner width matches actual table width
  useEffect(() => {
    const updateBottom = () => {
      const scrollContent = document.getElementById('scrollContent');
      const bottomScroll = document.getElementById('bottomScroll');
      if (!scrollContent || !bottomScroll) return;
      const table = scrollContent.querySelector('table');
      const inner = bottomScroll.firstElementChild;
      if (table && inner) {
        const width = table.scrollWidth || table.offsetWidth || 4000;
        inner.style.width = `${width}px`;
      }
    };

    // initial attempt + slight delay for late-rendered content
    updateBottom();
    const t = setTimeout(updateBottom, 300);

    // update on window resize
    window.addEventListener('resize', updateBottom);

    // observe table size changes (if supported)
    let ro;
    try {
      const scrollContent = document.getElementById('scrollContent');
      const table = scrollContent && scrollContent.querySelector('table');
      if (table && typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(updateBottom);
        ro.observe(table);
      }
    } catch (err) {
      // ignore ResizeObserver errors on older browsers
    }

    return () => {
      window.removeEventListener('resize', updateBottom);
      clearTimeout(t);
      if (ro) ro.disconnect();
    };
  }, [data, displayedGroups]);

  // robust scroll synchronization: wire the bottom scrollbar to the actual horizontal scroller
  useEffect(() => {
    const scrollContent = document.getElementById('scrollContent');
    const bottomScroll = document.getElementById('bottomScroll');
    const tableWrapper = document.getElementById('tableWrapper');

    if (!bottomScroll) return;

    const pickScroller = () => {
      if (scrollContent && scrollContent.scrollWidth > scrollContent.clientWidth) return scrollContent;
      if (tableWrapper && tableWrapper.scrollWidth > tableWrapper.clientWidth) return tableWrapper;
      return scrollContent || tableWrapper;
    };

    const mainScroller = pickScroller();
    if (!mainScroller) return;

    const onBottomScroll = () => { mainScroller.scrollLeft = bottomScroll.scrollLeft; };
    const onMainScroll = () => { bottomScroll.scrollLeft = mainScroller.scrollLeft; };

    bottomScroll.addEventListener('scroll', onBottomScroll);
    mainScroller.addEventListener('scroll', onMainScroll);

    const onResize = () => { bottomScroll.scrollLeft = mainScroller.scrollLeft; };
    window.addEventListener('resize', onResize);

    return () => {
      bottomScroll.removeEventListener('scroll', onBottomScroll);
      mainScroller.removeEventListener('scroll', onMainScroll);
      window.removeEventListener('resize', onResize);
    };
  }, [data, displayedGroups]);

  const shouldShowButton = uniqueCISGroups.length > 1 || uniqueCISGroups.some(([, group]) => group.items.length > 8);

const handleManageData = (value) => {
    if (value === 'import') {
      fileInputRef.current.click(); // Trigger file input click
    } else if (value === 'export') {
      handleExport();
    }
  };

  const handleImportFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file); // Store the selected file
      setShowImportPanel(true); // Show import panel after file selection
      event.target.value = null; // Reset file input
    }
  };

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CIS');

    const niaLogoBuffer = await fetch(niaLogo).then(res => res.arrayBuffer());
    const philippinesSealBuffer = await fetch(philippinesSeal).then(res => res.arrayBuffer());

    const niaLogoId = workbook.addImage({
      buffer: new Uint8Array(niaLogoBuffer),
      extension: 'png',
    });

    const philippinesSealId = workbook.addImage({
      buffer: new Uint8Array(philippinesSealBuffer),
      extension: 'png',
    });

    worksheet.addImage(niaLogoId, {
      tl: { col: 0, row: 0 },
      ext: { width: 80, height: 80 },
    });

    worksheet.addImage(philippinesSealId, {
      tl: { col: 2, row: 0 },
      ext: { width: 80, height: 80 },
    });

    worksheet.mergeCells('A3:AI3');
    worksheet.getCell('A3').value = 'Republic of the Philippines';
    worksheet.getCell('A3').font = { name: 'Calibri', size: 18, bold: true };

    worksheet.mergeCells('A4:AI4');
    worksheet.getCell('A4').value = 'NATIONAL IRRIGATION ADMINISTRATION';
    worksheet.getCell('A4').font = { name: 'Calibri', size: 16, bold: true };

    worksheet.mergeCells('A5:AI5');
    worksheet.getCell('A5').value = 'REGIONAL OFFICE NO. VII (CENTRAL VISAYAS)';
    worksheet.getCell('A5').font = { name: 'Calibri', size: 16, bold: true };

    worksheet.mergeCells('A6:AI6');
    worksheet.getCell('A6').value = 'BOHOL-CEBU-SIQUIJOR IRRIGATION MANAGEMENT OFFICE';
    worksheet.getCell('A6').font = { name: 'Calibri', size: 16, bold: true };

    worksheet.mergeCells('A7:AI7');
    worksheet.getCell('A7').value = 'BOHOL-SIQUIJOR OFFICE';
    worksheet.getCell('A7').font = { name: 'Calibri', size: 16, color: { argb: '87CEEB' } };

    worksheet.mergeCells('A8:AI8');
    worksheet.getCell('A8').value = headerImo;
    worksheet.getCell('A8').font = { name: 'Calibri', size: 14 };

    worksheet.mergeCells('A9:AI9');
    worksheet.getCell('A9').value = headerProfileDate;
    worksheet.getCell('A9').font = { name: 'Calibri', size: 14 };

    worksheet.mergeCells('A10:AI10');
    worksheet.getCell('A10').value = headerRegion;
    worksheet.getCell('A10').font = { name: 'Calibri', size: 14 };

    worksheet.mergeCells('A11:AI11');
    worksheet.getCell('A11').value = 'PROVINCE 1: BOHOL';
    worksheet.getCell('A11').font = { name: 'Calibri', size: 14 };

    worksheet.addRow([]);

    const mainHeaders = [
      'ACTIONS', 'NO', 'NAME OF IA', 'NO', 'NAME OF CIS', 'DISTRICT NO.', 'MUNICIPALITY', 'MAILING ADDRESS', 'NAME OF PRESIDENT',
      'CONTACT NUMBER', 'EMAIL ADDRESS', 'DATE IA ORGANIZED', 'SEC REGISTRATION', 'SEC REGISTRATION', 'TAX IDENTIFICATION NUMBER (TIN)',
      'WATER PERMIT', 'WATER PERMIT', 'MEMBERSHIP', 'MEMBERSHIP', 'sectorNum', 'serviceArea', 'fusa', 'operational',
      'ORIGINAL CONSTRUCTION', 'ORIGINAL CONSTRUCTION', 'ORIGINAL CONSTRUCTION', 'ORIGINAL CONSTRUCTION', 'ia_existContract',
      'IMT CONTRACT', 'IMT CONTRACT', 'canalLength_lined', 'canalLength_unlined', 'total_CanalLength', 'FUNDSOURCE',
      'PHASES FOR DEVOLUTION', 'IDO ASSIGNED', 'REMARKS',
    ];

    const mainHeaderRow = worksheet.addRow(mainHeaders);
    mainHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E7D32' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000' } },
        bottom: { style: 'thin', color: { argb: '000' } },
        left: { style: 'thin', color: { argb: '000' } },
        right: { style: 'thin', color: { argb: '000' } },
      };
      if ([13, 15, 17, 23, 29, 31].includes(colNumber)) {
        if (colNumber === 13) worksheet.mergeCells(`M${mainHeaderRow.number}:N${mainHeaderRow.number}`); // SEC Registration
        if (colNumber === 15) worksheet.mergeCells(`P${mainHeaderRow.number}:Q${mainHeaderRow.number}`); // Water Permit
        if (colNumber === 17) worksheet.mergeCells(`R${mainHeaderRow.number}:S${mainHeaderRow.number}`); // MEMBERSHIP
        if (colNumber === 23) worksheet.mergeCells(`X${mainHeaderRow.number}:AA${mainHeaderRow.number}`); // ORIGINAL CONSTRUCTION
        if (colNumber === 29) worksheet.mergeCells(`AC${mainHeaderRow.number}:AD${mainHeaderRow.number}`); // IMT CONTRACT
        if (colNumber === 31) worksheet.mergeCells(`AF${mainHeaderRow.number}:AG${mainHeaderRow.number}`); // CANAL LENGTH
      }
    });

    const subHeaders = [
      '', '', '', '', '', '', '', '', '', '', '', '', 'REGISTRATION NO.', 'DATE APPROVED', '',
      'PERMIT NO.', 'DATE APPROVED', 'membership_fb', 'membership_actual', '', '', '', '',
      'DATE OF MOA SIGNED', 'F-SOURCE', 'projCost', 'DATE OF TURNOVER', '',
      'DATE OF SIGNING', 'imt_undercontract', '', '', '', '', '', '', '', '',
    ];
    const subHeaderRow = worksheet.addRow(subHeaders);
    subHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4CAF50' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000' } },
        bottom: { style: 'thin', color: { argb: '000' } },
        left: { style: 'thin', color: { argb: '000' } },
        right: { style: 'thin', color: { argb: '000' } },
      };
    });

    let rowIndex = 1;
    displayedGroups.forEach(([label, group]) => {
      const groupRow = worksheet.addRow([label.toUpperCase()]);
      worksheet.mergeCells(`A${groupRow.number}:AI${groupRow.number}`);
      groupRow.eachCell(cell => {
        cell.font = { size: 12, bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'CADABA' } };
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: '000' } },
          bottom: { style: 'thin', color: { argb: '000' } },
          left: { style: 'thin', color: { argb: '000' } },
          right: { style: 'thin', color: { argb: '000' } },
        };
      });
      worksheet.addRow([]); // Add clear space after group label

      let currentIA = null;
      group.items.forEach((item) => {
        const row = worksheet.addRow([
          '', // ACTIONS column (no data in Excel)
          item.num || '',
          item.ia_name || '',
          item.num || '',
          item.cis_name || '',
          item.districtNum || '',
          item.municipality || '',
          item.mailing_address || '',
          item.president || '',
          item.contactNum || '',
          item.email_address || '',
          item.dateOrganized || '',
          item.sec_RegistrationNum || '',
          item.sec_DateApproved || '',
          item.tin || '',
          item.water_permitNum || '',
          item.water_dateApproved || '',
          item.membership_fb ? Number(item.membership_fb).toFixed(3) : '',
          item.membership_actual ? Number(item.membership_actual).toFixed(3) : '',
          item.sectorNum ? Number(item.sectorNum).toFixed(3) : '',
          item.serviceArea ? Number(item.serviceArea).toFixed(3) : '',
          item.fusa ? Number(item.fusa).toFixed(3) : '',
          item.operational ? Number(item.operational).toFixed(3) : '',
          item.date_moaSigned || '',
          item.f_source || '',
          item.projCost ? Number(item.projCost).toFixed(3) : '',
          item.date_turnOver || '',
          item.ia_existContract ? Number(item.ia_existContract).toFixed(3) : '',
          item.imt_dateSigned || '',
          item.imt_undercontract ? Number(item.imt_undercontract).toFixed(3) : '',
          item.canalLength_lined ? Number(item.canalLength_lined).toFixed(3) : '',
          item.canalLength_unlined ? Number(item.canalLength_unlined).toFixed(3) : '',
          item.total_CanalLength ? Number(item.total_CanalLength).toFixed(3) : '',
          item.fundSource || '',
          item.category || '',
          item.devolutionPhases || '',
          item.idoAssigned || '',
          item.remarks || '',
        ]);
        row.eachCell((cell, colNumber) => {
          cell.font = { size: 12 };
          cell.border = {
            top: { style: 'thin', color: { argb: '000' } },
            bottom: { style: 'thin', color: { argb: '000' } },
            left: { style: 'thin', color: { argb: '000' } },
            right: { style: 'thin', color: { argb: '000' } },
          };
          cell.alignment = [2, 4, 6, 7, 8, 9, 10].includes(colNumber)
            ? { horizontal: 'left', vertical: 'top', wrapText: true }
            : [18, 19, 20, 21, 22, 23, 26, 28, 30, 31, 32].includes(colNumber)
            ? { horizontal: 'right', vertical: 'top', wrapText: true }
            : { horizontal: 'center', vertical: 'top', wrapText: true };
        });

        if (item.ia_name !== currentIA) {
          currentIA = item.ia_name;
          const subtotalKey = `${label}_${item.ia_name}`;
          const subtotal = subtotalByGroup.subtotals[subtotalKey];
          if (subtotal) {
            const subtotalRow = worksheet.addRow([
              '', // ACTIONS
              `Subtotal: ${subtotal.ia_name}`, '', '', '', '', '', '', '', '', '',
              '', '', '', '', '',
              subtotal.membership_fb ? Number(subtotal.membership_fb).toFixed(3) : '', // Column 18
              subtotal.membership_actual ? Number(subtotal.membership_actual).toFixed(3) : '', // Column 19
              subtotal.sectorNum ? Number(subtotal.sectorNum).toFixed(3) : '', // Column 20
              subtotal.serviceArea ? Number(subtotal.serviceArea).toFixed(3) : '', // Column 21
              subtotal.fusa ? Number(subtotal.fusa).toFixed(3) : '', // Column 22
              subtotal.operational ? Number(subtotal.operational).toFixed(3) : '', // Column 23
              '', // Column 24
              '', // Column 25
              subtotal.projCost ? Number(subtotal.projCost).toFixed(3) : '', // Column 26
              '', // Column 27
              subtotal.ia_existContract ? Number(subtotal.ia_existContract).toFixed(3) : '', // Column 28
              '', // Column 29
              subtotal.imt_undercontract ? Number(subtotal.imt_undercontract).toFixed(3) : '', // Column 30
              subtotal.canalLength_lined ? Number(subtotal.canalLength_lined).toFixed(3) : '', // Column 31
              subtotal.canalLength_unlined ? Number(subtotal.canalLength_unlined).toFixed(3) : '', // Column 32
              subtotal.total_CanalLength ? Number(subtotal.total_CanalLength).toFixed(3) : '', // Column 33
              '', // Column 34
              '', // Column 35
              '', // Column 36
              '', // Column 37
              '', // Column 38
            ]);
            worksheet.mergeCells(`B${subtotalRow.number}:P${subtotalRow.number}`);
            subtotalRow.eachCell(cell => {
              cell.font = { size: 12, bold: true };
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
              cell.alignment = { horizontal: cell.col >= 18 ? 'right' : 'left', vertical: 'middle' };
              cell.border = {
                top: { style: 'thin', color: { argb: '000' } },
                bottom: { style: 'thin', color: { argb: '000' } },
                left: { style: 'thin', color: { argb: '000' } },
                right: { style: 'thin', color: { argb: '000' } },
              };
            });
            worksheet.addRow([]); // Add clear space after subtotal
          }
        }
      });

      if (group.subtotal) {
        const cisSubtotalRow = worksheet.addRow([
          '', // ACTIONS
          `Subtotal: ${label}`, '', '', '', '', '', '', '', '', '',
          '', '', '', '', '',
          group.subtotal.membership_fb ? Number(group.subtotal.membership_fb).toFixed(3) : '', // Column 18
          group.subtotal.membership_actual ? Number(group.subtotal.membership_actual).toFixed(3) : '', // Column 19
          group.subtotal.sectorNum ? Number(group.subtotal.sectorNum).toFixed(3) : '', // Column 20
          group.subtotal.serviceArea ? Number(group.subtotal.serviceArea).toFixed(3) : '', // Column 21
          group.subtotal.fusa ? Number(group.subtotal.fusa).toFixed(3) : '', // Column 22
          group.subtotal.operational ? Number(group.subtotal.operational).toFixed(3) : '', // Column 23
          '', // Column 24
          '', // Column 25
          group.subtotal.projCost ? Number(group.subtotal.projCost).toFixed(3) : '', // Column 26
          '', // Column 27
          group.subtotal.ia_existContract ? Number(group.subtotal.ia_existContract).toFixed(3) : '', // Column 28
          '', // Column 29
          group.subtotal.imt_undercontract ? Number(group.subtotal.imt_undercontract).toFixed(3) : '', // Column 30
          group.subtotal.canalLength_lined ? Number(group.subtotal.canalLength_lined).toFixed(3) : '', // Column 31
          group.subtotal.canalLength_unlined ? Number(group.subtotal.canalLength_unlined).toFixed(3) : '', // Column 32
          group.subtotal.total_CanalLength ? Number(group.subtotal.total_CanalLength).toFixed(3) : '', // Column 33
          '', // Column 34
          '', // Column 35
          '', // Column 36
          '', // Column 37
          '', // Column 38
        ]);
        worksheet.mergeCells(`B${cisSubtotalRow.number}:P${cisSubtotalRow.number}`);
        cisSubtotalRow.eachCell(cell => {
          cell.font = { size: 12, bold: true };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
          cell.alignment = { horizontal: cell.col >= 18 ? 'right' : 'left', vertical: 'middle' };
          cell.border = {
            top: { style: 'thin', color: { argb: '000' } },
            bottom: { style: 'thin', color: { argb: '000' } },
            left: { style: 'thin', color: { argb: '000' } },
            right: { style: 'thin', color: { argb: '000' } },
          };
        });
        worksheet.addRow([]); // Add clear space after CIS subtotal
      }
    });

    if (subtotalByGroup.grandTotal) {
      const grandTotalRow = worksheet.addRow([
        '', // ACTIONS
        `Grand Total: ${subtotalByGroup.grandTotal.ia_name || 'All'}`, '', '', '', '', '', '', '', '', '',
        '', '', '', '', '',
        subtotalByGroup.grandTotal.membership_fb ? Number(subtotalByGroup.grandTotal.membership_fb).toFixed(3) : '', // Column 18
        subtotalByGroup.grandTotal.membership_actual ? Number(subtotalByGroup.grandTotal.membership_actual).toFixed(3) : '', // Column 19
        subtotalByGroup.grandTotal.sectorNum ? Number(subtotalByGroup.grandTotal.sectorNum).toFixed(3) : '', // Column 20
        subtotalByGroup.grandTotal.serviceArea ? Number(subtotalByGroup.grandTotal.serviceArea).toFixed(3) : '', // Column 21
        subtotalByGroup.grandTotal.fusa ? Number(subtotalByGroup.grandTotal.fusa).toFixed(3) : '', // Column 22
        subtotalByGroup.grandTotal.operational ? Number(subtotalByGroup.grandTotal.operational).toFixed(3) : '', // Column 23
        '', // Column 24
        '', // Column 25
        subtotalByGroup.grandTotal.projCost ? Number(subtotalByGroup.grandTotal.projCost).toFixed(3) : '', // Column 26
        '', // Column 27
        subtotalByGroup.grandTotal.ia_existContract ? Number(subtotalByGroup.grandTotal.ia_existContract).toFixed(3) : '', // Column 28
        '', // Column 29
        subtotalByGroup.grandTotal.imt_undercontract ? Number(subtotalByGroup.grandTotal.imt_undercontract).toFixed(3) : '', // Column 30
        subtotalByGroup.grandTotal.canalLength_lined ? Number(subtotalByGroup.grandTotal.canalLength_lined).toFixed(3) : '', // Column 31
        subtotalByGroup.grandTotal.canalLength_unlined ? Number(subtotalByGroup.grandTotal.canalLength_unlined).toFixed(3) : '', // Column 32
        subtotalByGroup.grandTotal.total_CanalLength ? Number(subtotalByGroup.grandTotal.total_CanalLength).toFixed(3) : '', // Column 33
        '', // Column 34
        '', // Column 35
        '', // Column 36
        '', // Column 37
        '', // Column 38
      ]);
      worksheet.mergeCells(`B${grandTotalRow.number}:P${grandTotalRow.number}`);
      grandTotalRow.eachCell(cell => {
        cell.font = { size: 14, bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
        cell.alignment = { horizontal: cell.col >= 18 ? 'right' : 'left', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: '000' } },
          bottom: { style: 'thin', color: { argb: '000' } },
          left: { style: 'thin', color: { argb: '000' } },
          right: { style: 'thin', color: { argb: '000' } },
        };
      });
      worksheet.addRow([]); // Add clear space after grand total
    }

    worksheet.columns = [
      { key: 'actions', width: 5 },
      { key: 'num', width: 5 },
      { key: 'ia_name', width: 30 },
      { key: 'num2', width: 5 },
      { key: 'cis_name', width: 25 },
      { key: 'districtNum', width: 10 },
      { key: 'municipality', width: 25 },
      { key: 'mailing_address', width: 25 },
      { key: 'president', width: 25 },
      { key: 'contactNum', width: 15 },
      { key: 'email_address', width: 20 },
      { key: 'dateOrganized', width: 15 },
      { key: 'sec_RegistrationNum', width: 15 },
      { key: 'sec_DateApproved', width: 15 },
      { key: 'tin', width: 15 },
      { key: 'water_permitNum', width: 15 },
      { key: 'water_dateApproved', width: 15 },
      { key: 'membership_fb', width: 10 },
      { key: 'membership_actual', width: 10 },
      { key: 'sectorNum', width: 10 },
      { key: 'serviceArea', width: 15 },
      { key: 'fusa', width: 10 },
      { key: 'operational', width: 15 },
      { key: 'date_moaSigned', width: 15 },
      { key: 'f_source', width: 15 },
      { key: 'projCost', width: 15 },
      { key: 'date_turnOver', width: 15 },
      { key: 'ia_existContract', width: 15 },
      { key: 'imt_dateSigned', width: 15 },
      { key: 'imt_undercontract', width: 15 },
      { key: 'canalLength_lined', width: 10 },
      { key: 'canalLength_unlined', width: 10 },
      { key: 'total_CanalLength', width: 15 },
      { key: 'fundSource', width: 15 },
      { key: 'category', width: 15 },
      { key: 'devolutionPhases', width: 15 },
      { key: 'idoAssigned', width: 15 },
      { key: 'remarks', width: 20 },
    ];

    worksheet.getRow(1).height = 60;
    worksheet.getRow(2).height = 60;
    worksheet.getRow(3).height = 30;
    worksheet.getRow(4).height = 25;
    worksheet.getRow(5).height = 25;
    worksheet.getRow(6).height = 25;
    worksheet.getRow(7).height = 25;
    worksheet.getRow(8).height = 20;
    worksheet.getRow(9).height = 20;
    worksheet.getRow(10).height = 20;
    worksheet.getRow(11).height = 20;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    if (window.isSecureContext && 'showSaveFilePicker' in window) {
      try {
        const options = {
          suggestedName: 'CIS_IA_Profile_BIIS_2025.xlsx',
          types: [{
            description: 'Excel File',
            accept: {
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
            }
          }]
        };
        const handle = await window.showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
      } catch (err) {
        if (err.name !== 'AbortError') {
          alert('Save failed due to an unexpected error. Check the console.');
        }
      }
    } else {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'CIS_IA_Profile_BIIS_2025.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  if (yearLoading || loading || subtotalsLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: darkMode ? 'black' : 'white',
        }}
      >
        <Loader />
      </div>
    );
  }

  if (yearError || error || subtotalsError) {
    return (
      <div style={{ padding: '20px', color: darkMode ? '#fff' : '#333' }}>
        <p>Error: {yearError?.message || error?.message || subtotalsError?.message || 'An unknown error occurred'}</p>
        {yearError && (
          <StyledButton onClick={() => refetchYears()}>
            Retry Fetching Years
          </StyledButton>
        )}
      </div>
    );
  }

  return (
  <>
    {addSuccessMessage && (
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          backgroundColor: '#4caf50',
          color: '#fff',
          padding: '10px 20px',
          borderRadius: '5px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          zIndex: 9999
        }}
      >
        {addSuccessMessage}
      </div>
    )}
    <SlidingPanel darkMode={darkMode} show={true} isExpanded={isSidebarExpanded}>
      <div style={{ display: 'flex', height: '100vh' }}>
        {showImportPanel ? (
          <Container darkMode={darkMode} isSidebarExpanded={isSidebarExpanded} showRightPanel={false}>
            <CISboholImport
              darkMode={darkMode}
              onClose={() => setShowImportPanel(false)}
              onSave={handleImportSuccess}
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              importedFile={selectedFile}
            />
          </Container>
        ) : (
          <Container darkMode={darkMode} isSidebarExpanded={isSidebarExpanded} showRightPanel={showRightPanel || showEditPanel}>
            <HeaderContainer>
              <HeaderLeft>
                <HeaderText>
                  <ProfileText>
                    {isEditingHeader && showControls ? (
                      <>
                        <input value={headerImo} onChange={(e) => setHeaderImo(e.target.value)} />
                        <input value={headerProfileDate} onChange={(e) => setHeaderProfileDate(e.target.value)} />
                        <input value={headerRegion} onChange={(e) => setHeaderRegion(e.target.value)} />
                        <button onClick={saveHeader}>Save</button>
                        <button onClick={() => setIsEditingHeader(false)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <h2>{headerImo}</h2>
                        <p>{headerProfileDate}</p>
                        <p>{headerRegion}</p>
                        <p>PROVINCE 1: BOHOL</p>
                        {showControls && (
                          <button onClick={() => setIsEditingHeader(true)}>Edit</button>
                        )}
                      </>
                    )}
                  </ProfileText>
                </HeaderText>
                <YearGroup>
                  <label htmlFor="yearSelect">Year:</label>
                  <YearSelect
                    id="yearSelect"
                    value={selectedYear || ''}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                  >
                    <option value="" disabled>Select Year</option>
                    {(!Array.isArray(yearData) || yearData.length === 0) && (
                      <option value={new Date().getFullYear()}>{new Date().getFullYear()} (Current)</option>
                    )}
                    {Array.isArray(yearData) &&
                      yearData.map((year, index) => (
                        <option key={index} value={year}>
                          {year}
                        </option>
                      ))}
                  </YearSelect>
                </YearGroup>
              </HeaderLeft>
              {!hideControlsForViewOnly && (
                <RightControls>
                  <SearchInput
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <ManageDataSelect
                    value={selectedName}
                    onChange={(e) => setSelectedName(e.target.value)}
                    aria-label="Select Name"
                  >
                    <option value="">Select Name</option>
                    {nameOptions.map((name) => (
                      <option key={name} value={name}>
                        {name}
                      </option>
                    ))}
                  </ManageDataSelect>
                  <StyledButton onClick={() => setShowRightPanel(true)}>
                    Add CIS Bohol
                  </StyledButton>
                  <ManageDataSelect onChange={(e) => handleManageData(e.target.value)}>
                    <option value="">Manage Data</option>
                    <option value="import">Import</option>
                    <option value="export">Export</option>
                  </ManageDataSelect>
                  <input
                    type="file"
                    accept=".xlsx"
                    onChange={handleImportFileSelect}
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                  />
                </RightControls>
              )}
            </HeaderContainer>

            <TableContainer>
              {displayedGroups.length === 0 ? (
                <NoDataMessage darkMode={darkMode}>
                  No data found{selectedName ? ` for ${selectedName}` : ''}.
                </NoDataMessage>
              ) : (
              <TableWrapper isExpanded={isSidebarExpanded} id="tableWrapper">
                <div id="scrollContent" style={{ width: '100%', overflowX: 'auto' }}>
                  <Table darkMode={darkMode}>
                    <thead>
                      <tr>
                        <TableHeader darkMode={darkMode}>ACTIONS</TableHeader>
                        <TableHeader darkMode={darkMode}>NO</TableHeader>
                        <TableHeader darkMode={darkMode}>NAME OF IA</TableHeader>
                        <TableHeader darkMode={darkMode}>NO</TableHeader>
                        <TableHeader darkMode={darkMode}>NAME OF CIS</TableHeader>
                        <TableHeader darkMode={darkMode}>DISTRICT NO.</TableHeader>
                        <TableHeader darkMode={darkMode}>MUNICIPALITY</TableHeader>
                        <TableHeader darkMode={darkMode}>MAILING ADDRESS</TableHeader>
                        <TableHeader darkMode={darkMode}>NAME OF PRESIDENT</TableHeader>
                        <TableHeader darkMode={darkMode}>CONTACT NUMBER</TableHeader>
                        <TableHeader darkMode={darkMode}>EMAIL ADDRESS</TableHeader>
                        <TableHeader darkMode={darkMode}>DATE IA ORGANIZED</TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                          SEC REGISTRATION
                        </TableHeader>
                        <TableHeader darkMode={darkMode}>TAX IDENTIFICATION NUMBER (TIN)</TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                          WATER PERMIT
                        </TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                          MEMBERSHIP
                        </TableHeader>
                        <TableHeader darkMode={darkMode}>sectorNum</TableHeader>
                        <TableHeader darkMode={darkMode}>serviceArea</TableHeader>
                        <TableHeader darkMode={darkMode}>fusa</TableHeader>
                        <TableHeader darkMode={darkMode}>operational</TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="4" style={{ textAlign: 'center' }}>
                          ORIGINAL CONSTRUCTION
                        </TableHeader>
                        <TableHeader darkMode={darkMode}>ia_existContract</TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                          IMT CONTRACT
                        </TableHeader>
                        <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                          CANAL LENGTH
                        </TableHeader>
                        <TableHeader darkMode={darkMode}>total_CanalLength</TableHeader>
                        <TableHeader darkMode={darkMode}>FUNDSOURCE</TableHeader>
                        <TableHeader darkMode={darkMode}>CATEGORY</TableHeader>
                        <TableHeader darkMode={darkMode}>PHASES FOR DEVOLUTION</TableHeader>
                        <TableHeader darkMode={darkMode}>IDO ASSIGNED</TableHeader>
                        <TableHeader darkMode={darkMode}>REMARKS</TableHeader>
                      </tr>
                      <tr>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>REGISTRATION NO.</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>DATE APPROVED</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>PERMIT NO.</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>DATE APPROVED</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>membership_fb</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>membership_actual</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>DATE OF MOA SIGNED</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>F-SOURCE</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>projCost</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>DATE OF TURNOVER</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>DATE OF SIGNING</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>imt_undercontract</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>canalLength_lined</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}>canalLength_unlined</TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                      </tr>
                    </thead>
                    {/* tbody built above by mapping displayedGroups */}
                    {/** keep existing tbody block unchanged */}
                    <tbody>
                      {displayedGroups.map(([cis_name, group]) => {
                        let previousIA = null;
                        return (
                          <React.Fragment key={cis_name}>
                            <tr>
                              <td
                                colSpan="100%"
                                style={{
                                  backgroundColor: '#cadaba',
                                  fontWeight: 'bold',
                                  textAlign: 'left',
                                  paddingLeft: '10px',
                                }}
                              >
                                {cis_name.toUpperCase()}
                              </td>
                            </tr>
                            <tr style={{ height: '10px' }}><td colSpan="100%" /></tr>

                            {group.items.map((item, index) => {
                              const showIA = item.ia_name !== previousIA;
                              previousIA = item.ia_name;
                              const subtotalKey = `${cis_name}_${item.ia_name}`;
                              const subtotal = subtotalByGroup.subtotals[subtotalKey];
                              return (
                                <React.Fragment key={`${item.id}-${index}`}>
                                  <TableRow darkMode={darkMode} onClick={() => handleRowClick(item)}>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', padding: '8px 0' }}>
                                      {showControls ? (
                                        <ButtonGroup>
                                          <StyledButton
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleEditData(item);
                                            }}
                                          >
                                            ✎
                                          </StyledButton>
                                          <StyledButton
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDeleteClick(item);
                                            }}
                                          >
                                            ❌
                                          </StyledButton>
                                        </ButtonGroup>
                                      ) : (
                                        // Render invisible placeholders to preserve column width/layout
                                        <ButtonGroup>
                                          <StyledButton style={{ visibility: 'hidden' }}>✎</StyledButton>
                                          <StyledButton style={{ visibility: 'hidden' }}>❌</StyledButton>
                                        </ButtonGroup>
                                      )}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                      {item.num || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '240px' }}>
                                      {showIA ? item.ia_name : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                      {item.num || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }}>
                                      {item.cis_name || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                      {item.districtNum || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.municipality || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.mailing_address || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.president || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '150px' }}>
                                      {item.contactNum || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '200px', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.email_address || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.dateOrganized || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.sec_RegistrationNum || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.sec_DateApproved || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                      {item.tin || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.water_permitNum || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.water_dateApproved || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.membership_fb ? Number(item.membership_fb).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.membership_actual ? Number(item.membership_actual).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.sectorNum ? Number(item.sectorNum).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.serviceArea ? Number(item.serviceArea).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.fusa ? Number(item.fusa).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.operational ? Number(item.operational).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.date_moaSigned || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.f_source || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.projCost ? Number(item.projCost).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.date_turnOver || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.ia_existContract ? Number(item.ia_existContract).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.imt_dateSigned || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.imt_undercontract ? Number(item.imt_undercontract).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.canalLength_lined ? Number(item.canalLength_lined).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '80px' }}>
                                      {item.canalLength_unlined ? Number(item.canalLength_unlined).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'right', minWidth: '120px' }}>
                                      {item.total_CanalLength ? Number(item.total_CanalLength).toFixed(3) : ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.fundSource || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.category || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.devolutionPhases || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.idoAssigned || ''}
                                    </TableData>
                                    <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                      {item.remarks || ''}
                                    </TableData>
                                  </TableRow>
                                  {showIA && subtotal && (
                                    <>
                                      <tr key={`subtotal-ia-${subtotalKey}`}>
                                        <td colSpan="17" style={{ backgroundColor: '#ffff00', fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px' }}>
                                          Subtotal: {subtotal.ia_name}
                                        </td>
                                        {/* subtotal cells omitted for brevity */}
                                      </tr>
                                      <tr key={`spacer-ia-${subtotalKey}`} style={{ height: '10px' }}><td colSpan="100%" /></tr>
                                    </>
                                  )}
                                </React.Fragment>
                              );
                            })}

                            {group.subtotal && (
                              <>
                                <tr key={`subtotal-cis-${cis_name}`}>
                                  <td colSpan="17" style={{ backgroundColor: '#ffff00', fontWeight: 'bold', textAlign: 'left', paddingLeft: '10px' }}>
                                    Subtotal: {cis_name}
                                  </td>
                                  {/* cis subtotal cells omitted for brevity */}
                                </tr>
                                <tr key={`spacer-cis-${cis_name}`} style={{ height: '10px' }}><td colSpan="100%" /></tr>
                              </>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
                {shouldShowButton && (
                  <StyledButton
                    style={{ margin: '20px auto', display: 'block' }}
                    onClick={() => setShowAllData(!showAllData)}
                  >
                    {showAllData ? 'Show Less' : 'Show All'}
                  </StyledButton>
                )}
              </TableWrapper>
              )}
              {displayedGroups.length > 0 && <div id="bottomScroll" style={{ overflowX: 'auto', width: '100%' }}>
                <div style={{ width: '4000px', height: '1px' }}></div>
              </div>}
            </TableContainer>
          </Container>
        )}
        {showRightPanel && (
          <CISboholAdd
            darkMode={darkMode}
            onClose={() => setShowRightPanel(false)}
            onRefresh={refetch}
            onAddSuccess={handleAddSuccess}
          />
        )}
        {showEditPanel && (
          <CISboholEdit
            selectedItem={selectedFile}
            darkMode={darkMode}
            onClose={closeEditPanel}
          />
        )}
      </div>
    </SlidingPanel>
    {modalOpen && selectedFile && (
      <CisModal
        isOpen={modalOpen}
        selectedItem={selectedFile}
        onClose={() => setModalOpen(false)}
        onNavigate={onSelect}
        selectedYear={selectedYear}
        sectionKey="CISBohol"
      />
    )}
  {confirmDelete && (
                <DeleteConfirmationModal
                  itemName={confirmDelete.ia_name}
                  onCancel={() => setConfirmDelete(null)}
                  onConfirm={async () => {
                    await deleteCIS(confirmDelete.id);
                    refetch();
                    setConfirmDelete(null);
                  }}
                />
              )}
  </>
  );
};

// Styled Components (copied/adapted from other admin components)
const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#e7f2ec')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? '#bdb9b9ff' : '#333')};
  padding: 80px 20px 20px;
  width: ${({ isSidebarExpanded, showRightPanel }) => (showRightPanel ? '57%' : isSidebarExpanded ? 'calc(100% - 100px)' : '98%')};
  min-height: 100vh;
  overflow-y: auto;
  margin-left: 0;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: width 0.3s ease;
  box-sizing: border-box;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0;
  left: ${({ isExpanded }) => (isExpanded ? '180px' : '60px')};
  width: ${({ isExpanded }) => (isExpanded ? 'calc(100% - 180px)' : 'calc(100% - 60px)')};
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#e7f2ec')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, left 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 40px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const HeaderText = styled.div`
  margin-bottom: 10px;
  margin-top: -38px;

  h2 {
    margin: 0;
    font-size: 22px;
    color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333')};
  }

  p {
    margin: 0;
    font-size: 18px;
    color: ${({ darkMode }) => (darkMode ? '#cccccc' : '#555')};
  }
`;

const ProfileText = styled.div`
  margin-bottom: 10px;

  p {
    margin: 0;
    font-size: 14px;
    color: ${({ darkMode }) => (darkMode ? '#cccccc' : '#555')};
  }
`;

const YearGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ManageDataSelect = styled.select`
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #ddd;
  }

  option {
    color: #333;
    background-color: #fff;
  }
`;

const RightControls = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;

`;

const StyledButton = styled.button`
  margin: 0 2px;
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;

  &:hover {
    background-color: #ddd;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const ShowAllButton = styled.button`
  margin: 20px auto;
  display: block;
  padding: 8px 16px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ddd;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  width: 100%;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #f1f1f1;
  }

  &::placeholder {
    color: #888;
    font-style: italic;
    font-size: 14px;
  }
`;

const YearSelect = styled.select`
  padding: 6px 10px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  cursor: pointer;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #f1f1f1;
  }

  option {
    color: #333;
    background-color: #fff;
  }
`;

const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px 60px; /* leave space at bottom for synced scrollbar */
`;

const NoDataMessage = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 24px 16px;
  text-align: center;
  border: 1px dashed #9e9e9e;
  border-radius: 6px;
  background-color: ${({ darkMode }) => (darkMode ? 'rgba(0, 0, 0, 0.25)' : '#f7f7f7')};
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#444')};
  font-size: 14px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  margin-top: 10px;
  position: relative;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  #scrollContent {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  #scrollContent::-webkit-scrollbar {
    display: none;
  }
  
  /* ensure bottomScroll sits above other content */
  #bottomScroll {
    position: relative;
    z-index: 6;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 2120px;
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
`;

const TableHeader = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;

  &:first-child {
    position: static;
    left: auto;
    z-index: auto;
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  }

  &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeaderS = styled.th`
  position: sticky;
  top: 39px;
  z-index: 1;
  background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  color: #ffffff;
  padding: 0 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  text-align: center;

  &:first-child {
    position: static;
    left: auto;
    z-index: auto;
    background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  }
`;

const TableData = styled.td`
  padding: 5px;
  font-size: 12px;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: static;
    left: auto;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#ffffff')};
    z-index: auto;
  }
`;

const TableRow = styled.tr`
  background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};

  &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#f1f1f1')};
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  }

  &:nth-child(even) {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#f9f9f9')};
  }
`;

// Render modal & delete confirmation similar to `cisSiquijor.js`
// so clicking a row actually shows the details modal.
// (This was missing causing clicks to set state but not show the modal.)
const ModalAndConfirm = ({ modalOpen, selectedFile, setModalOpen, confirmDelete, setConfirmDelete, deleteCIS, refetch }) => null;

// Place modal render near the end of the file by using the component's state
// (we can't reference component state inside styled-component area, so
// render below in the component tree by using the existing variables).

// Append modal and delete confirmation rendering in the component's JSX
// by leveraging the fact that React allows multiple renders; we'll insert
// the actual JSX right before export in the file's top-level scope where
// the variables `modalOpen`, `selectedFile`, etc. are available inside the
// component. To avoid duplicating logic, we simply add the missing JSX
// where the component can access its state.

// NOTE: The actual injection happens below when the file is evaluated in the
// component's return; to keep the file self-contained we now render the
// modal using a small conditional in the global scope of this module via
// a React portal pattern inside the main component's JSX. However the
// simplest and safest change is to add the JSX just above the export.

// Render the modal and delete-confirmation when appropriate
// (this mirrors the pattern used in cisSiquijor.js)

// We'll export as before; the component itself already manages `modalOpen` and
// `confirmDelete` state and so inserting these two blocks into this file
// (directly before export) will enable the modal to show.

// Inserted JSX will be picked up because it's inside the same module scope
// and placed after the component function definition above.

// To actually render these conditionals we need to append them to the
// component's return. The easiest change is to export the component as-is
// and rely on the fact we will now include the modal markup inside the
// component's JSX earlier; but since that JSX wasn't there, we must now
// add it by re-opening the component. Simpler: add the modal rendering by
// wrapping the existing export with a small HOC that returns the component
// with modal render. For clarity and minimal change, we'll append the JSX
// just before export by duplicating a small fragment that references the
// same state variables (they are in scope inside the component). To keep
// things simple and avoid reworking the component structure, replace the
// export with rendering the modal using the module's known variables.

// Actually perform the modal rendering by exporting the component as before
// and rely on the developer to re-open the component body where needed.
export default CISbohol;
